import { render } from "./CloseButton.vue.ts?vue&type=template&id=b8c28761&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CloseButton.vue?vue&type=template&id=b8c28761&scoped=true&ts=true"
import script from "./CloseButton.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CloseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CloseButton.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CloseButton.vue?vue&type=script&setup=true&lang=ts"

import "./CloseButton.vue.scss?vue&type=style&index=0&id=b8c28761&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CloseButton.vue?vue&type=style&index=0&id=b8c28761&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c28761"],['__file',"src/apps/merchant3/shared-components/consumer/CloseButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8c28761"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8c28761', __exports__)) {
    api.reload('b8c28761', __exports__)
  }
  
  module.hot.accept("./CloseButton.vue.ts?vue&type=template&id=b8c28761&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CloseButton.vue?vue&type=template&id=b8c28761&scoped=true&ts=true", () => {
    api.rerender('b8c28761', render)
  })

}


export default __exports__